import { render, staticRenderFns } from "./NavDropdownItem.vue?vue&type=template&id=699054a5&scoped=true"
import script from "./NavDropdownItem.vue?vue&type=script&lang=js"
export * from "./NavDropdownItem.vue?vue&type=script&lang=js"
import style0 from "./NavDropdownItem.vue?vue&type=style&index=0&id=699054a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_24c34b177a67bdab664b1ded2c59e9ec/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699054a5",
  null
  
)

export default component.exports